module.exports = __webpack_public_path__ + "static/media/text_date.3d310613.svg";